import React from 'react'
import { Fragment, useState, useEffect, useRef } from "react";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import { Dialog, Menu, Transition } from "@headlessui/react";
import Logo from "../../../../images/logo.png";
import moment from "moment";
import ProfileAvatar from "../../../../images/profile-avatar.png";
import { Disclosure } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { Bars3Icon, BellIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { MagnifyingGlassIcon } from "@heroicons/react/20/solid";
import Notifications from "../../../notifications";
import {
  useGetProfessionalInfoQuery,
  useLazySearchLeadsQuery,
} from "../../../../store/professionalInfo";
import { formatDate, generateFullImageUrl } from "../../../../utilities/utils";
import { useLazyGetLeadDataQuery } from "../../../../store/leadDetails";
import Loader from "../../../commons/Loader";
import { useDispatch, useSelector } from "react-redux";
import { setMatches } from "../../../../store/reducers/matchesSlice";
import { useGetNotificationDetailsQuery } from "../../../../store/professionalNotifications";
import { setNotificationsList } from "../../../../store/reducers/notificationsSlice";
import {
  navigation,
  footerNavigation,
  userNavigation,
} from "../../../../routes/AdminRouteConfig";
import { useGetAllCreditRequestsQuery } from "../../../../store/admin/creditRequests";
import SignOutModal from "../../../modal/SIgnOutModal";
import { clearParticipant } from "../../../../store/twilio-reducers/chatSlice";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const DashboardAdminLayout = (props) => {
  console.log("rendering.......");
  
  const dispatch = useDispatch();
  const [isShowFilteredData, setIsShowFilteredData] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isActive, setIsActive] = useState("");
  const [isSubItemActive, setIsSubItemActive] = useState("Admin/Owner Data");
  const [isNotificationActive, setIsNotificationActive] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [filteredLeads, setFilteredLeads] = useState([]);
  const [searchLoader, setSearchLoader] = useState(false);
  const [notificationActive, setNotificationActive] = useState(false);
  const [showSignOutModal, setShowSignOutModal] = useState(false);
  const navigate = useNavigate();

  const { data: professionaInfo } = useGetProfessionalInfoQuery();
  const {
    first_name = "",
    last_name = "",
    profession,
    photo = "",
  } = (professionaInfo && professionaInfo?.data) || {};
  const [pendingRequests, setPendingRequests] = useState([]);
  const professionName = profession ? profession?.name : "";
  const location = useLocation();
  const currentDate = moment().format("dddd, MMM Do, YYYY");
  const fullName = first_name + " " + last_name;
  localStorage.setItem("adminName", fullName);

  const [trigger, result] = useLazySearchLeadsQuery();
  const [leadtrigger, leadResult] = useLazyGetLeadDataQuery();
  const dropdownRef = useRef(null);

  const { data: notificationDetails } = useGetNotificationDetailsQuery();
  const { data: allCreditRequests } = useGetAllCreditRequestsQuery({
    statuses: "pending",
  });

  const notificationDetailsBadge = useSelector(
    (state) => state.notificationsSlice.notificationsList
  );

  const hasDrPrefix = professionaInfo?.data?.professions.some(
    (profession) => profession.add_dr_prefix === 1
  );

  useEffect(() => {
    // Filter requests based on status
    const pending =
      allCreditRequests &&
      allCreditRequests?.data?.filter(
        (request) => request.status === "Pending"
      );

    // Set state variables with filtered results
    setPendingRequests(pending);
  }, [allCreditRequests]);

  const badgeSign =
    notificationDetailsBadge &&
    notificationDetailsBadge.length > 0 &&
    notificationDetailsBadge?.filter(
      (notification) => notification.read_at == null
    );

  useEffect(() => {
    if (notificationDetails) {
      dispatch(setNotificationsList(notificationDetails?.data ?? []));
    }
  }, [notificationDetails]);

  const handleNotification = () => {
    // Toggle the notificationActive state
    setNotificationActive((prevState) => !prevState);
  };

  useEffect(() => {
    if (
      location.pathname.includes("users") ||
      location.pathname.includes("professional-profile")
    ) {
      if (isNotificationActive === true) {
        setIsNotificationActive(false);
      }
      setIsActive("Users");
      if (location.pathname.includes("leads")) {
        setIsSubItemActive("Leads");
      } else {
        setIsSubItemActive("Professionals");
      }
    } else if (location.pathname.includes("matches")) {
      if (isNotificationActive === true) {
        setIsNotificationActive(false);
      }
      setIsActive("Matches");
      setIsSubItemActive("Successful Matches");
    } else if (location.pathname.includes("unmatched")) {
      if (isNotificationActive === true) {
        setIsNotificationActive(false);
      }
      setIsActive("Matches");
      setIsSubItemActive("Failed Matches");
    } else if (location.pathname.includes("pending")) {
      if (isNotificationActive === true) {
        setIsNotificationActive(false);
      }
      setIsActive("Matches");
      setIsSubItemActive("Pending Matches");
    } else if (location.pathname.includes("credit")) {
      if (isNotificationActive === true) {
        setIsNotificationActive(false);
      }
      setIsActive("Credit Requests");
    } else if (location.pathname.includes("invoices")) {
      if (isNotificationActive === true) {
        setIsNotificationActive(false);
      }
      setIsActive("Invoices");
    } else if (location.pathname.includes("tools")) {
      if (isNotificationActive === true) {
        setIsNotificationActive(false);
      }
      setIsActive("Admin Tools");
      if (location.pathname.includes("email-templates")) {
        setIsSubItemActive("Email Templates");
      } else if (location.pathname.includes("global-alerts")) {
        setIsSubItemActive("Global Alerts");
      } else {
        setIsSubItemActive("Professions");
      }
    } else if (location.pathname.includes("education-center")) {
      if (isNotificationActive === true) {
        setIsNotificationActive(false);
      }
      setIsActive("Education Center");
    } else if (location.pathname.includes("settings")) {
      if (isNotificationActive === true) {
        setIsNotificationActive(false);
      }
      setIsActive("Settings");
    } else if (location.pathname.includes("support")) {
      if (isNotificationActive === true) {
        setIsNotificationActive(false);
      }
      setIsActive("Support");
      if (location.pathname.includes("lead-inquiries")) {
        setIsSubItemActive("Lead Inquiries");
      } else {
        setIsSubItemActive("Professional Inquiries");
      }
    } else {
      if (isNotificationActive === true) {
        setIsNotificationActive(false);
      }
      setIsActive("Dashboard");
      if (location.pathname.includes("professional-data")) {
        setIsSubItemActive("Professional Data");
      } else if (location.pathname.includes("match-data")) {
        setIsSubItemActive("Leads/Match Data");
      } else {
        setIsSubItemActive("Admin/Owner Data");
      }
    }
  }, [location.pathname]);

  useEffect(() => {
    if (result?.data?.data) {
      setIsShowFilteredData(true);
      setFilteredLeads(result?.data?.data);
      dispatch(setMatches(result?.data?.data));
    }
  }, [result]);

  const handleSearchChange = (e) => {
    e.preventDefault();
    setSearchValue(e.target.value);
    if (e.target.value.length >= 3) {
      trigger({ query: e.target.value });
    } else {
      setFilteredLeads([]);
    }
  };

  const handleLeadSelect = (lead) => {
    setSearchValue("");
    setFilteredLeads([]);
    setSearchLoader(true);
    leadtrigger(lead?.id).then((data) => {
      setSearchLoader(false);
      navigate(`/dashboard/matches/${lead.id}`, {
        state: { leadData: data?.data },
      });
    });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsShowFilteredData(false);
        setSearchValue("");
        setFilteredLeads([]);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [handleLeadSelect]);

  const handleAllSearchLeads = () => {
    setFilteredLeads([]);
    setSearchValue("");
    navigate("/dashboard/matches", {
      state: {
        searchBarLead: true,
      },
    });
  };

  const handleClose = () => {
    setShowSignOutModal(false);
  };

  const handleSignOut = () => {
    dispatch(clearParticipant());
    localStorage.removeItem("token");
    localStorage.removeItem("isUpdateInsurancePer")
    localStorage.removeItem("smsTemplate");
    window.location.replace("/signin"); 
  };

  const handleLinkClick = (e) => {
    const currentURL = window.location.href;
    let targetURL = "https://app.helpmatch.com/admin/nova/login";

    if (currentURL.includes("staging") || currentURL.includes("localhost")) {
      targetURL = "https://staging.app.helpmatch.com/admin/nova/login";
    }

    window.open(targetURL, "_blank");
    e.preventDefault();
  };

  const handelLeadCapClick =(e)=>{
    const currentURL = window.location.href;
    let targetURL = "https://app.helpmatch.com/admin/dashboard";

    if (currentURL.includes("staging") || currentURL.includes("localhost")) {
      targetURL = "https://staging.app.helpmatch.com/admin/dashboard";
    }
    window.open(targetURL, "_blank");
    e.preventDefault();
  }

  return (
    <>
      <div>
        <Transition.Root show={sidebarOpen} as={Fragment}>
          <Dialog
            as="div"
            className="relative z-[999] lg:hidden"
            onClose={setSidebarOpen}
          >
            <Transition.Child
              as={Fragment}
              enter="transition-opacity ease-linear duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="transition-opacity ease-linear duration-300"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-900/80" />
            </Transition.Child>

            <div className="fixed inset-0 flex">
              <Transition.Child
                as={Fragment}
                enter="transition ease-in-out duration-300 transform"
                enterFrom="-translate-x-full"
                enterTo="translate-x-0"
                leave="transition ease-in-out duration-300 transform"
                leaveFrom="translate-x-0"
                leaveTo="-translate-x-full"
              >
                <Dialog.Panel className="relative mr-16 flex w-full max-w-xs flex-1">
                  <Transition.Child
                    as={Fragment}
                    enter="ease-in-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in-out duration-300"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                  >
                    <div className="absolute left-full top-0 flex w-16 justify-center pt-5">
                      <button
                        type="button"
                        className="-m-2.5 p-2.5"
                        onClick={() => setSidebarOpen(false)}
                      >
                        <span className="sr-only">Close sidebar</span>
                        <XMarkIcon
                          className="h-6 w-6 text-white"
                          aria-hidden="true"
                        />
                      </button>
                    </div>
                  </Transition.Child>
                  <div className="flex grow flex-col overflow-y-auto border-r border-gray-200 bg-white">
                    <div className="py-[32px] pl-7 flex items-center">
                      <Link to="/" className="inline-block">
                        <img
                          className="w-auto h-[34px]"
                          src={Logo}
                          alt="Your Company"
                        />
                      </Link>
                    </div>
                    <div className="p-5 pr-4 bg-[#F1F4F6] mb-5">
                      <p className="text-lg leading-[160%] font-bold text-customGray">
                        Welcome, {hasDrPrefix && "Dr."}{" "}
                        {`${hasDrPrefix ? last_name : first_name}`}
                      </p>
                      <p className="text-base leading-[160%] font-medium text-[#768B9F]">
                        {currentDate}
                      </p>
                    </div>
                    <nav className="flex flex-1 flex-col">
                      <ul role="list" className="flex flex-1 flex-col gap-y-7">
                        <li>
                          <ul role="list" className="">
                            {navigation.map((item) => (
                              <li key={item.name}>
                                {!item.children ? (
                                  <>
                                    <Link
                                      to={item.href}
                                      className={classNames(
                                        item.name === isActive
                                          ? "bg-primary text-white"
                                          : "text-[#485868] hover:bg-[#EBF7FF]",
                                        "group flex gap-x-3 py-[19px] px-5 text-base leading-[160%] font-bold duration-300 relative"
                                      )}
                                      onClick={() => setSidebarOpen(false)}
                                    >
                                      <item.icon
                                        className={classNames(
                                          item.name === isActive
                                            ? "text-white"
                                            : "text-[#485868]",
                                          "h-6 w-6 shrink-0"
                                        )}
                                        aria-hidden="true"
                                      />
                                      {item.name}
                                      {item.badge &&
                                        pendingRequests?.length > 0 && (
                                          <span className="absolute right-5 -translate-y-1/2 top-1/2 inline-flex items-center justify-center bg-[#D834A0] w-9 h-9 rounded-[50%] text-[10px] font-bold border-[2.5px] leading-[130%] text-white border-white">
                                            {pendingRequests?.length}
                                          </span>
                                        )}
                                    </Link>
                                    <hr className="w-[90%] mx-auto" />
                                  </>
                                ) : (
                                  <Disclosure as="div" defaultOpen>
                                    {({ open }) => (
                                      <>
                                        <Disclosure.Button
                                          onClick={(e) => {
                                            e.preventDefault(true);
                                            setSidebarOpen(false);
                                            navigate(item.href);
                                          }}
                                          className={classNames(
                                            item.name === isActive
                                              ? "bg-primary text-white"
                                              : "text-[#485868] hover:bg-[#EBF7FF]",
                                            "group flex gap-x-3 py-[19px] px-5 text-base leading-[160%] font-bold duration-300 w-full"
                                          )}
                                        >
                                          <item.icon
                                            className={classNames(
                                              item.name === isActive
                                                ? "text-white"
                                                : "text-[#485868]",
                                              "h-6 w-6 shrink-0"
                                            )}
                                            aria-hidden="true"
                                          />
                                          {item.name}
                                          <ChevronDownIcon
                                            className={classNames(
                                              item.name === isActive
                                                ? "rotate-180 text-gray-500"
                                                : "text-gray-400",
                                              item.name === isActive
                                                ? "text-white"
                                                : "text-[#485868]",
                                              "ml-auto h-6 w-6 shrink-0"
                                            )}
                                            aria-hidden="true"
                                          />
                                        </Disclosure.Button>
                                        <Disclosure.Panel
                                          as="ul"
                                          className="mt-1 pl-10 pr-5"
                                        >
                                          {item.name === isActive &&
                                            item.children.map((subItem) =>
                                              subItem.name === "nova" ? (
                                                <li>
                                                  <Link
                                                    to="#"
                                                    onClick={handleLinkClick}
                                                    className="flex justify-start items-center px-5 h-[46px] w-full rounded-md text-md leading-6 text-[#485868] font-medium capitalize"
                                                  >
                                                    nova
                                                  </Link>
                                                </li>
                                              ) : subItem.name === "Lead Cap" ? 
                                              <li key="nova-key">
                                              <Link
                                                to="#"
                                                className="text-[#485868] flex justify-start items-center px-5 h-[46px] w-full rounded-md text-base font-medium leading-[160%] capitalize"
                                                onClick={handelLeadCapClick}
                                              >
                                                Lead Cap
                                              </Link>
                                            </li>
                                               : (
                                                <li key={subItem.name}>
                                                  <Link
                                                    to={subItem.href}
                                                    onClick={() =>
                                                      setSidebarOpen(false)
                                                    }
                                                    className={classNames(
                                                      subItem.name ===
                                                        isSubItemActive
                                                        ? "bg-[#EBF7FF] text-primary"
                                                        : "text-[#485868]",
                                                      "flex justify-start items-center px-5 h-[46px] w-full rounded-md text-md leading-6 text-[#485868] font-medium"
                                                    )}
                                                  >
                                                    {subItem.name}
                                                  </Link>
                                                </li>
                                              )
                                            )}
                                        </Disclosure.Panel>
                                      </>
                                    )}
                                  </Disclosure>
                                )}
                              </li>
                            ))}
                          </ul>
                        </li>
                        <li className="mt-auto">
                          <ul>
                            {footerNavigation.map((item) => (
                              <li key={item.name}>
                                <Link
                                  onClick={() => {
                                    if (item.name === "Sign Out") {
                                      setShowSignOutModal(true);
                                    }
                                    setSidebarOpen(false);
                                  }}
                                  to={item.href}
                                  className={classNames(
                                    item.name === isActive
                                      ? "bg-primary text-white"
                                      : "text-[#485868] hover:bg-[#EBF7FF]",
                                    "group flex gap-x-3 py-[19px] px-5 text-base leading-[160%] font-bold duration-300 capitalize"
                                  )}
                                >
                                  <item.icon
                                    className={classNames(
                                      item.name === isActive
                                        ? "text-white"
                                        : "text-[#485868]",
                                      "h-6 w-6 shrink-0"
                                    )}
                                    aria-hidden="true"
                                  />
                                  {item.name}
                                </Link>
                                <hr className="w-[90%] mx-auto" />
                              </li>
                            ))}
                          </ul>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </Dialog>
        </Transition.Root>

        <div className="hidden lg:fixed lg:inset-y-0 lg:z-50 lg:flex lg:w-[272px] lg:flex-col">
          <div className="flex grow flex-col overflow-y-auto border-r border-gray-200 bg-white hide-scroll">
            <div className="py-[32px] pl-7 flex items-center">
              <Link to="/" className="inline-block">
                <img
                  className="w-auto h-[34px]"
                  src={Logo}
                  alt="Your Company"
                />
              </Link>
            </div>
            <div className="p-5 pr-4 bg-[#F1F4F6] mb-5">
              <p className="text-lg leading-[160%] font-bold text-customGray">
                Welcome, {hasDrPrefix && "Dr."}{" "}
                {`${hasDrPrefix ? last_name : first_name}`}
              </p>
              <p className="text-base leading-[160%] font-medium text-[#768B9F]">
                {currentDate}
              </p>
            </div>
            <nav className="flex flex-1 flex-col">
              <ul role="list" className="flex flex-1 flex-col gap-y-7">
                <li>
                  <ul role="list" className="">
                    {navigation.map((item) => (
                      <li key={item.name}>
                        {!item.children ? (
                          <>
                            <Link
                              onClick={() => {
                                if (item.name === "Sign Out") {
                                  localStorage.removeItem("token");
                                  localStorage.removeItem("smsTemplate");
                                  window.location.replace("/signin");
                                }
                              }}
                              to={item.href}
                              className={classNames(
                                item.name === isActive
                                  ? "bg-primary text-white"
                                  : "text-[#485868] hover:bg-[#EBF7FF]",
                                "group flex items-center gap-x-3 py-[19px] px-5 text-base leading-[160%] font-bold duration-300 relative"
                              )}
                            >
                              <item.icon
                                className={classNames(
                                  item.name === isActive
                                    ? "text-white"
                                    : "text-[#485868]",
                                  "h-6 w-6 shrink-0"
                                )}
                                aria-hidden="true"
                              />
                              {item.name}
                              {item.badge && pendingRequests?.length > 0 && (
                                <span className="absolute right-5 -translate-y-1/2 top-1/2 inline-flex items-center justify-center bg-[#D834A0] w-9 h-9 rounded-[50%] text-[10px] font-bold border-[2.5px] leading-[130%] text-white border-white">
                                  {pendingRequests?.length}
                                </span>
                              )}
                            </Link>
                            <hr className="w-[90%] mx-auto" />
                          </>
                        ) : (
                          <>
                            <Disclosure as="div" defaultOpen>
                              {({ open }) => (
                                <>
                                  <Disclosure.Button
                                    onClick={(e) => {
                                      e.preventDefault(true);
                                      navigate(item.href);
                                    }}
                                    className={classNames(
                                      item.name === isActive
                                        ? "bg-primary text-white"
                                        : "text-[#485868] hover:bg-[#EBF7FF]",
                                      "group flex gap-x-3 py-[19px] px-5 text-base leading-[160%] font-bold duration-300 w-full"
                                    )}
                                  >
                                    <item.icon
                                      className={classNames(
                                        item.name === isActive
                                          ? "text-white"
                                          : "text-[#485868]",
                                        "h-6 w-6 shrink-0"
                                      )}
                                      aria-hidden="true"
                                    />
                                    {item.name}
                                    <ChevronDownIcon
                                      className={classNames(
                                        item.name == isActive
                                          ? "rotate-180 text-gray-500"
                                          : "text-gray-400",
                                        item.name === isActive
                                          ? "text-white"
                                          : "text-[#485868]",
                                        "ml-auto h-6 w-6 shrink-0"
                                      )}
                                      aria-hidden="true"
                                    />
                                  </Disclosure.Button>
                                  <Disclosure.Panel
                                    as="ul"
                                    className="mt-1 pl-10 pr-5"
                                  >
                                    <>
                                      {item.name === isActive &&
                                        item.children.map((subItem) =>
                                          subItem.name === "nova" ? (
                                            <li key="nova-key">
                                              <Link
                                                to="#"
                                                className="text-[#485868] flex justify-start items-center px-5 h-[46px] w-full rounded-md text-base font-medium leading-[160%] capitalize"
                                                onClick={handleLinkClick}
                                              >
                                                nova
                                              </Link>
                                            </li>
                                          ) : subItem.name === "Lead Cap" ? 
                                          <li key="nova-key">
                                          <Link
                                            to="#"
                                            className="text-[#485868] flex justify-start items-center px-5 h-[46px] w-full rounded-md text-base font-medium leading-[160%] capitalize"
                                            onClick={handelLeadCapClick}
                                          >
                                            Lead Cap
                                          </Link>
                                        </li>
                                          : (
                                            <li key={subItem.name}>
                                              <Link
                                                to={subItem.href}
                                                className={classNames(
                                                  subItem.name ===
                                                    isSubItemActive
                                                    ? "bg-[#EBF7FF] text-primary"
                                                    : "text-[#485868]",
                                                  "flex justify-start items-center px-5 h-[46px] w-full rounded-md text-base font-medium leading-[160%] text-[#485868]"
                                                )}
                                              >
                                                {subItem.name}
                                              </Link>
                                            </li>
                                          )
                                        )}
                                    </>
                                  </Disclosure.Panel>
                                </>
                              )}
                            </Disclosure>
                            <hr className="w-[90%] mx-auto" />
                          </>
                        )}
                      </li>
                    ))}
                  </ul>
                </li>
                <li className="mt-auto">
                  <ul>
                    {footerNavigation.map((item) => (
                      <li key={item.name}>
                        <Link
                          onClick={() => {
                            if (item.name === "Sign Out") {
                              setShowSignOutModal(true);
                            }
                          }}
                          to={item.href}
                          className={classNames(
                            item.name === isActive
                              ? "bg-primary text-white"
                              : "text-[#485868] hover:bg-[#EBF7FF]",
                            "group flex gap-x-3 py-[19px] px-5 text-base leading-[160%] font-bold duration-300 capitalize"
                          )}
                        >
                          <item.icon
                            className={classNames(
                              item.name === isActive
                                ? "text-white"
                                : "text-[#485868]",
                              "h-6 w-6 shrink-0"
                            )}
                            aria-hidden="true"
                          />
                          {item.name}
                        </Link>
                        <hr className="w-[90%] mx-auto" />
                      </li>
                    ))}
                  </ul>
                </li>
              </ul>
            </nav>
          </div>
        </div>

        <div className="lg:pl-[272px]">
          <div className="sticky top-0 z-40 flex shrink-0 items-center gap-x-4 border-b border-gray-200 bg-white sm:gap-x-6 py-5 md:py-6 pl-8 pr-[42px] ">
            <button
              type="button"
              className="-m-2.5 p-2.5 text-gray-700 lg:hidden"
              onClick={() => setSidebarOpen(true)}
            >
              <span className="sr-only">Open sidebar</span>
              <Bars3Icon className="w-7 h-7" aria-hidden="true" />
            </button>

            <div
              className="h-6 w-px bg-gray-200 lg:hidden"
              aria-hidden="true"
            />

            <div className="flex flex-1 justify-end md:justify-between gap-x-4 lg:gap-x-6">
              <form
                className="relative z-20 hidden md:flex max-w-[calc(100%-280px)] lg:max-w-[calc(100%-350px)] xxl:max-w-[726px] w-full rounded-[10px] bg-[#F1F4F6] py-4 pl-4 pr-[3px]"
                action="#"
                method="GET"
              >
                <div className="w-full">
                  <label htmlFor="search-field" className="sr-only">
                    Search
                  </label>
                  <MagnifyingGlassIcon
                    className="pointer-events-none absolute inset-y-0 left-4 h-full w-5 text-[#485868]"
                    aria-hidden="true"
                  />
                  <input
                    id="search-field"
                    className="block h-full w-full border-0 py-0 pl-8 pr-8 text-[#485868] placeholder:text-[#768B9F] focus:ring-0 text-sm bg-transparent"
                    placeholder="Search by Name, Lead ID or Email"
                    type="text"
                    name="search"
                    value={searchValue}
                    onChange={handleSearchChange}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        setIsShowFilteredData(false);
                        e.preventDefault();
                        handleAllSearchLeads();
                      }
                    }}
                    autoComplete="off"
                  />
                  {searchValue.length > 0 && (
                    <XMarkIcon
                      className="absolute inset-y-0 right-4 h-full w-5 text-[#485868] cursor-pointer"
                      aria-hidden="true"
                      onClick={() => {
                        setSearchValue("");
                        setFilteredLeads([]);
                      }}
                    />
                  )}
                  {isShowFilteredData && (
                    <div
                      ref={dropdownRef}
                      className="absolute top-0 left-0 right-0 pt-[48px] bg-white border border-gray-300 rounded-lg shadow-lg -z-[1]"
                    >
                      <div
                        key={"lead.id"}
                        className="cursor-pointer px-4 py-2 relative pl-12 border-t border-strokeColor"
                        onClick={handleAllSearchLeads}
                      >
                        <MagnifyingGlassIcon
                          className="pointer-events-none absolute inset-y-0 left-4 h-full w-4 text-[#485868]"
                          aria-hidden="true"
                        />
                        All search results for {searchValue}
                      </div>
                      {filteredLeads?.length > 0 && searchValue && (
                        <ul className="scroller max-h-[260px] overflow-y-auto border-t border-strokeColor px-4">
                          {filteredLeads?.map((lead) => (
                            <li
                              key={lead.id}
                              className="cursor-pointer py-2 hover:bg-[#EBF7FF] flex items-center justify-between border-b border-[#EBEFF3]"
                              onClick={() => handleLeadSelect(lead)}
                            >
                              <span className="block text-sm font-normal">
                                {lead.first_name} {lead.last_name} <br />{" "}
                                {lead.email}
                              </span>{" "}
                              <span className="block text-sm font-normal">
                                {formatDate(lead.created_at)}
                              </span>
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  )}
                </div>
                {/* {searchLoader && <Loader isLoading={true} />} */}
              </form>
              <div className="flex items-center justify-end gap-x-4 lg:gap-x-6">
                <div className="-m-2.5 p-2.5 text-gray-400">
                  <span className="sr-only">View notifications</span>
                  <MagnifyingGlassIcon className="h-6 w-6 inline-block md:hidden mr-6" />
                  {/* <EnvelopeIcon
                    className="h-6 w-6 inline-block mr-6 cursor-pointer"
                    aria-hidden="true"
                  /> */}
                  <span className="relative">
                    <BellIcon
                      className={`h-6 w-6 inline-block cursor-pointer ${
                        badgeSign?.length > 0
                          ? "text-primary"
                          : "text-[#485868]"
                      }`}
                      aria-hidden="true"
                      onClick={handleNotification}
                    />
                    {badgeSign?.length > 0 && (
                      <svg
                        className="w-2 h-2 absolute top-0 right-1 border border-[#fff] fill-[#D834A0]"
                        viewBox="0 0 6 6"
                        aria-hidden="true"
                      >
                        <circle cx={3} cy={3} r={3} />
                      </svg>
                    )}
                  </span>
                </div>
                <div
                  className={`notificationDropdown absolute right-4 md:right-8 top-[68px] md:top-[98px] z-10 opacity-0 ${
                    notificationActive ? "notificationOpen" : ""
                  }`}
                >
                  <Notifications
                    setNotificationActive={setNotificationActive}
                    notificationActive={notificationActive}
                  />
                </div>
                <div
                  className="hidden lg:block lg:h-6 lg:w-px lg:bg-gray-200"
                  aria-hidden="true"
                />

                <Menu as="div" className="relative hidden md:block">
                  <Menu.Button className="-m-1.5 flex items-center p-1.5">
                    <span className="sr-only">Open user menu</span>
                    <img
                      className="h-8 w-8 rounded-full bg-gray-50"
                      src={photo ? generateFullImageUrl(photo) : ProfileAvatar}
                      alt=""
                    />
                    <span className="hidden lg:block">
                      <span
                        className="ml-4 text-base text-left font-bold leading-[160%] text-customGray block"
                        aria-hidden="true"
                      >
                        {`${first_name}`}
                      </span>
                      <span
                        className="ml-4 text-xs text-left font-medium leading-[160%] text-[#768B9F] block"
                        aria-hidden="true"
                      >
                        {professionName}
                      </span>
                    </span>
                  </Menu.Button>
                  <Transition
                    as={Fragment}
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                  >
                    <Menu.Items className="absolute right-0 z-10 mt-2.5 w-32 origin-top-right rounded-md bg-white py-2 shadow-lg ring-1 ring-gray-900/5 focus:outline-none capitalize cursor-pointer">
                      {userNavigation.map((item) => (
                        <Menu.Item key={item.name}>
                          {({ active }) => (
                            <Link
                              onClick={() => {
                                if (item.name === "Sign Out") {
                                  setShowSignOutModal(true);
                                }
                              }}
                              to={item.href}
                              replace={true}
                              className={classNames(
                                active ? "bg-gray-50" : "",
                                "block px-3 py-1 text-sm leading-6 text-gray-900 cursor-pointer"
                              )}
                            >
                              {item.name}
                            </Link>
                          )}
                        </Menu.Item>
                      ))}
                    </Menu.Items>
                  </Transition>
                </Menu>
              </div>
            </div>
          </div>
          <main className="py-8 bg-[#FAFAFB] min-h-[calc(100vh-99px)]">
            <div className="px-4 sm:px-6 lg:px-8 grid grid-cols-12 gap-6">
              <Outlet />
            </div>
          </main>
        </div>
      </div>
      <SignOutModal
        isOpen={showSignOutModal}
        handleClose={handleClose}
        handleSignOut={handleSignOut}
        text="Are you sure you want to log out of your account?"
      />
    </>
  );
};

export default React.memo(DashboardAdminLayout);
